import React from 'react';
import PropTypes from 'prop-types';

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  Filler,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  BarElement,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import styled from 'styled-components';
import theme from '../../theme';

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip
);

const ChartContainer = styled.div`
  & canvas {
    width: 270px;
    height: 270px;
    margin: auto;

    &:hover {
      position: relative;
      z-index: 2;
    }
  }

  canvas#race {
    position: relative;
    z-index: 100;
  }
`;

/*Note: The order of data.labels, data.datesets.data and datea.datesets.backgroundColor
must be in their corresponding information
Sample: https://www.chartjs.org/docs/latest/charts/doughnut.html
*/
const DoughnutChart = ({ config, customOptions = {}, showTooltip = false }) => {
  const defaultConfig = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: '#ffffff',
        borderWidth: 0,
      },
    ],
    ...config,
  };
  const options = {
    cutout: '85%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: showTooltip,
        backgroundColor: theme().colors.bgBox,
        position: 'nearest',
        yAlign: 'bottom',
        borderWidth: 1,
        borderColor: theme().colors.border,
        padding: 6,
        titleColor: theme().colors.textPrimary,
        titleFont: { weight: 'bold', size: '12px' },
        bodyColor: theme().colors.textPrimary,
        displayColors: false,
        zIndex: 100,
      },
    },
    hover: { mode: null },
    rotation: -90,
    circumference: 360,
  };
  return (
    <ChartContainer>
      <Doughnut
        data={defaultConfig}
        options={{ ...options, ...customOptions }}
      />
    </ChartContainer>
  );
};

DoughnutChart.propTypes = {
  config: PropTypes.object,
  customOptions: PropTypes.object,
  showTooltip: PropTypes.bool,
};

export default DoughnutChart;
